import { Provider } from './containerContext';

export default Provider;
